import React from "react";
import { useSelector } from "react-redux";
import AppLogo from "./appLogo.png";
import "./Loader.css";
import LoaderImage from "./loaderImg.png";

/**
 * A component that is shown whenever the application is sending a request to the backend
 *
 * @returns {JSX.Element}
 */

export default function Loader() {
  const loading = useSelector((state) => state.loader.loading);

  if (!loading) {
    return null;
  }

  return (
    <div className="loader-container" id="global-loader">
      <div className="loader-image-container">
        <img src={LoaderImage} alt="loader" className="loader-img-setting" />
        <img src={AppLogo} alt="Logo" className="AppLogo-setting" />
      </div>
    </div>
  );
}
